import React, { FC } from 'react';
import { useRecoilState } from 'recoil';

// Components
import { LayoutComponents } from '../../components';

// Subcomponents
import { WelcomeStep, CalculatorAmbarcatiune } from './subcomponents';

// Store
import { CalculatorStepState } from '../../store/calculator.store';

// Styles
import { CalculatorWrapper } from './calculator.styles';

/*
function getStepContent(step) {
  switch (step) {
    case 0:
      return <AddressForm />;
    case 1:
      return <PaymentForm />;
    case 2:
      return <Review />;
    default:
      throw new Error('Unknown step');
  }
}
*/

export const CalculatorPage: FC = () => {
  const [calculatorStep] = useRecoilState(CalculatorStepState);

  return (
    <CalculatorWrapper>
      <LayoutComponents.Backdrop />
      { calculatorStep === 'welcome' && <WelcomeStep /> }
      { calculatorStep === 'ambarcatiune' && <CalculatorAmbarcatiune /> }
    </CalculatorWrapper>
  )
}

/*
<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>

              <Typography variant="h5" gutterBottom>
                Thank you for your order.
              </Typography>
              <Typography variant="subtitle1">
                Your order number is #2001539. We have emailed your order
                confirmation, and will send you an update when your order has
                shipped.
              </Typography>

              {activeStep !== 0 && (
                  <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                    Back
                  </Button>
                )}

                <Button
                  variant="contained"
                  onClick={handleNext}
                  sx={{ mt: 3, ml: 1 }}
                >
                  {activeStep === steps.length - 1 ? 'Place order' : 'Next'}
                </Button>
              </Box>

              */